'use client'
import { useCompareStore } from '@/store/compare'
import Image from 'next/image'
import { toast } from 'react-toastify'

interface AnotherProps {
  data: Product
  productSelected: {
    product: IVariantsProduct | undefined
    options: Record<string, string>
  }
  isCompared?: boolean
  customRender?: React.ReactNode
}

export const AnotherButton = ({ data, productSelected, isCompared = false, customRender }: AnotherProps) => {
  const { createCompareList, addToCompareList, compareUid, removeFromCompareList } = useCompareStore()

  const addItemToCompareList = async () => {
    let result
    let idToast = toast.loading('Processing')
    const uidDecode = Buffer?.from(
      productSelected?.product?.product?.uid ?? data?.uid ?? '',
      'base64'
    ).toString('utf-8')
    if (isCompared) {
      result = await removeFromCompareList(uidDecode)
    } else {
      if (compareUid) {
        result = await addToCompareList(uidDecode)
      } else {
        result = await createCompareList([uidDecode])
      }
    }
    toast.update(idToast, {
      render: result?.message,
      type: result?.status ?? 'success',
      isLoading: false,
      autoClose: 3 * 1000,
      closeButton: true,
    })
  }
  if(customRender) {
    return <div onClick={addItemToCompareList}>{customRender}</div>
  }
  return (
    <div key={1} className={`border border-gray-300 rounded-md bg-white text-black p-2 z-10 cursor-pointer transition-colors hover:bg-black hover:text-white hover:border-black sm:flex sm:border-none sm:items-center sm:justify-center sm:rounded-sm ${isCompared ? 'bg-black text-white border-black' : ''}`} onClick={addItemToCompareList}>
      <Image className={`sm:w-6 ${isCompared ? "brightness-0 invert" : "hover:brightness-0 hover:invert"}`} src="/assets/images/ico_refresh.svg" width={24} height={24} alt="So sánh sản phẩm" />
    </div>
  )
}